/* eslint-disable @typescript-eslint/camelcase */
import { SetFromPlace } from '../types';
const cityTypes = ['locality', 'administrative_area_level_2'];
const airportTypes = ['airport'];
const { LOCATION_FETCH_URL } = process.env;

const getCityName = (addressComponents): string | null => {
  const types = [
    'locality',
    'administrative_area_level_2',
    'administrative_area_level_1'
  ];
  for (const addressComponent of addressComponents) {
    for (const componentType of addressComponent.types) {
      if (types.indexOf(componentType) >= 0) {
        return addressComponent.long_name;
      }
    }
  }
  return null;
};
export const getPlaceObject = async (placeId): Promise<SetFromPlace> => {
  const { results } = await fetch(
    `${LOCATION_FETCH_URL}?place_id=${placeId}`
  ).then(r => r.json());
  if (results.length > 0) {
    return {
      address: results[0].formatted_address,
      latitude: results[0].geometry.location.lat,
      longitude: results[0].geometry.location.lng,
      place_id: placeId,
      is_city: results[0].types.some(type => cityTypes.includes(type)),
      is_airport:
        results[0].types.some(type => airportTypes.includes(type)) ||
        (results[0].formatted_address || '').toLowerCase().includes('airport'),
      city: getCityName(results[0].address_components)
    };
  } else {
    return {
      address: null,
      latitude: null,
      longitude: null,
      place_id: placeId,
      is_city: null,
      is_airport: null,
      city: null
    };
  }
};
